import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

export default new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/index',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/index'], resolve)
    },
    {
      path: '/apartment',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/apartment'], resolve)
    },
    {
      path: '/apartment/apartmentDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/apartmentDetail'], resolve)
    },
    {
      path: '/login',
      meta: { keepAlive: false },
      component:  resolve => require(['../components/apartment/login'], resolve)
    },
    {
      path: '/register',
      meta: { keepAlive: false },
      component:  resolve => require(['../components/apartment/register'], resolve)
    },
    {
      path: '/forget',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/forget'], resolve)
    },
    {
     path: '/index/roomDetail',
      meta: { keepAlive: false },
     component: resolve => require(['../components/apartment/roomDetail'], resolve)
    },
    {
      path: '/order',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/order'], resolve)
    },
    {
      path: '/templateList',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/templateList'], resolve)
    },
    {
      path: '/templateList/addTemplate',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/addTemplate'], resolve)
    },
    {
      path: '/manualOrder',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/manualOrder'], resolve)
    },
    {
      path: '/notificationDescDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/notificationDescDetail'], resolve)
    },
    {
      path: '/exchangeDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/exchangeDetail'], resolve)
    },
    {
      path: '/sheet',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/sheet'], resolve)
    },
    {
      path: '/onlineStoreConfig',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/onlineStoreConfig'], resolve)
    },
    //58发房
    {
      path: '/publishRoomTo58',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/publishRoom58'], resolve)
    },
    //闲鱼发房
    {
      path: '/publishRoomToXY',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/publishRoomXY'], resolve)
    },
    {
      path: '/sale',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/sale'], resolve)
    },
    {
      path: '/couponManage',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/couponManage'], resolve)
    },
    {
      path: '/couponManage/couponManageEdit',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/couponManageEdit'], resolve)
    },
    {
      path: '/couponManage/residenceCouponDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/residenceCouponDetail'], resolve)
    },
    {
      path: '/feeDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/feeDetail'], resolve)
    },
    {
      path: '/residence',
      meta: { keepAlive: true,isBack:false},
      component: resolve => require(['../components/apartment/residence'], resolve),
    },
    {
      path: '/apartmentSettle',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/apartmentSettle'], resolve)
    },
    {
      path: '/account',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/account'], resolve)
    },
    {
      path: '/enterprise',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/enterprise'], resolve)
    },
    {
      path: '/enterpriseLegalPerson',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/enterpriseLegalPerson'], resolve)
    },
    {
      path: '/payeeList',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/payeeList'], resolve)
    },
    {
      path: '/accountInfo',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/accountInfo'], resolve)
    },
    {
      path: '/analysisHtmlPage',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/analysisHtmlPage'], resolve)
    },
    {
      path: '/sysConfig',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/sysConfig'], resolve)
    },
    {
      path: '/formAddAdmin',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formAddAdmin'], resolve)
    },
    {
      path: '/formEditAdmin',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formEditAdmin'], resolve)
    },
    {
      path: '/apartmentAddRoom',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/apartmentAddRoom'], resolve)
    },
    {
      path: '/formAddSheet',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formAddSheet'], resolve)
    },
    {
      path: '/addWaterRate',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/addWaterRate'], resolve)
    },
    {
      path: '/rent',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/rent'], resolve)
    },
    {
      path: '/formAddSheetLog',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formAddSheetLog'], resolve)
    },
    {
      path: '/formRelet',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formRelet'], resolve)
    },
    {
      path: '/formCheckOut',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formCheckOut'], resolve)
    },
    {
      path: '/offSaleRoom',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/offSaleRoom'], resolve)
    },
    {
      path: '/formRental',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formRental'], resolve)
    },
    {
      path: '/formExchangeRoom',
      meta: { keepAlive: false },
      component: resolve => require(['../components/dialog/formExchangeRoom'], resolve)
    },
    {
      path: '/registerSuccess',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/registeSuccess'], resolve)
    },
    {
      path: '/browserError',
      meta: { keepAlive: false },
      component: resolve => require(['../components/base/browserError'], resolve)
    },
    {
      path: '/residence/residenceRoomDetail',
      name:"residenceRoomDetail",
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/residenceRoomDetail'], resolve)
    },
    {
      path: '/residenceApartmentDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/residenceApartmentDetail'], resolve)
    },
    {
      path: '/residence/formAddRoom',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/formAddRoom'], resolve)
    },
    {
      path: '/residence/apartmentAddRoomSource',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/apartmentAddRoomSource'], resolve)
    },
    {
      path: '/residence/residentialHouseEdit',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/residentialHouseEdit'], resolve)
    },
    {
      path: '/couponManage/apartmentActivity',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/apartmentActivity'], resolve)
    },
    {
      path: '/IRR',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/IRR'], resolve)
    },
    {
      path: '/lookAtHouseManage',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/lookAtHouseManage'], resolve)
    },
    {
      path: '/patrolRoomStatistics',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/patrolRoomStatistics'], resolve)
    },
    {
      path: '/rentalRateAndRenewalRate',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/rentalRateAndRenewalRate'], resolve)
    },
    {
      path: '/evictionContract',
      mate: { keepAlive: false },
      component: resolve => require(['../components/apartment/evictionContract'], resolve)
    },
    //资产管理
    {
      path: '/assetList',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/assetList'], resolve)
    },
    {
      path: '/assetOwnerBillList',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/assetOwnerBillList'], resolve)
    },
    {
      path: '/assetOperationReport',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/assetOperationReport'], resolve)
    },
    {
      path: '/assetList/addOwnerContract',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/addOwnerContract'], resolve)
    },
    {
      path: '/assetOperationReport/assetOperationReportDetail',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/assetOperationReportDetail'], resolve)
    },
    {
      path: '/assetOperationReport/assetOperationReportUpload',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/assetOperationReportUpload'], resolve)
    },
    {
      path: '/storeList',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/storeList'], resolve)
    },
    {
      path: '/guidePrice',
      meta: { keepAlive: false },
      component: resolve => require(['../components/apartment/guidePrice'], resolve)
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js